import { makeStyles } from '@gogame/components';

export const useStyles = makeStyles((theme) => ({
  sidebar: {
    padding: '16px',
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  content: {
    padding: '16px 0 16px 16px',
    maxHeight: 'calc(100vh - 145px)',
    overflowY: 'scroll',
  },
  root: {
    flexGrow: 1,
  },
}));
